import { defineNuxtRouteMiddleware, navigateTo } from '#imports'

import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'

import { ROUTE_NAMES } from '~/constants/routes'

// eslint-disable-next-line consistent-return
export default defineNuxtRouteMiddleware((to, from) => {
  const { isUserAuthenticated, isUserAuthenticatedSeller } = useUserStore()

  const DO_NOT_REQUIRE_AUTHENTICATION = [ROUTE_NAMES.AUTH.LOGIN]
  const DO_NOT_REQUIRE_TO_BE_SELLER = [ROUTE_NAMES.AUTH.REGISTER]
  const requireAuthentication = !DO_NOT_REQUIRE_AUTHENTICATION.includes(
    to.name as string,
  )
  const requireBeingSeller =
    requireAuthentication &&
    !DO_NOT_REQUIRE_TO_BE_SELLER.includes(to.name as string)

  if (requireBeingSeller) {
    // If you need to be an authenticated seller, but are not authenticated => go to login.
    if (!isUserAuthenticated.value) {
      return navigateTo({
        name: ROUTE_NAMES.AUTH.LOGIN,
        query: {
          next: from.path as string,
        },
      })
    }

    // If you need to be an authenticated seller, but are not a seller yet => go to register.
    if (!isUserAuthenticatedSeller.value) {
      return navigateTo({
        name: ROUTE_NAMES.AUTH.REGISTER,
      })
    }
  } else {
    // You don't need to be an authenticated seller for the route, but are one => go to homepage.
    // eslint-disable-next-line no-lonely-if
    if (isUserAuthenticatedSeller.value) {
      return navigateTo({
        name: ROUTE_NAMES.HOME.INDEX,
      })
    }
  }

  if (requireAuthentication) {
    // If you need to be connected, but are not => go to login.
    if (!isUserAuthenticated.value) {
      return navigateTo({
        name: ROUTE_NAMES.AUTH.LOGIN,
        query: {
          next: from.path as string,
        },
      })
    }
  } else {
    // If you don't need to be connected, but are connected => go to register.
    // eslint-disable-next-line no-lonely-if
    if (isUserAuthenticated.value) {
      return navigateTo({
        name: ROUTE_NAMES.AUTH.REGISTER,
      })
    }
  }
})
